import LayoutPage from '@/view/layout/Layout'

/*
 * ERM 2026: existe una única ficha, siempre asociada a una mesa.
 * Las rutas de la ficha de local se retiraron junto con ese modelo.
 */
export default [{
    path: '/sheet',
    component: LayoutPage,
    children: [{
        path: 'mesa/2026-erm/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-2026-erm',
        component: () => import('@/view/sheet/2026-ERM/EditFicha'),
    }, {
        path: 'mesa/2026-erm-lima/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-2026-erm-lima',
        component: () => import('@/view/sheet/2026-ERM/EditFichaLima'),
    }, {
        path: 'mesa/2026-erm-provincia/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-2026-erm-provincia',
        component: () => import('@/view/sheet/2026-ERM/EditFichaProvincia'),
    }, {
        path: 'mesa/erm26/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-erm26',
        component: () => import('@/view/sheet/2026-ERM/EditFicha'),
    }
  /*  , {
        path: 'mesa/temp/:procesoElectoralId/:localVotacionId/:turno?',
        name: 'sheet-mesa-edit-erm26',
        component: () => import('@/view/sheet/EditFichaLocal'),
    }*/]
}]
